import { rest } from 'msw';

interface ArasResponse {
  status: string,
  code: number,
  message?: string | null,
  data?: Record<string, unknown> | null,
  extra?: string | null
}

const handlers = [
  rest.get('*/api/v1/init', (req, res, ctx) => res(
    ctx.json({
      status: 'OK',
      data: {},
    }),
  )),
  rest.post('*/api/v1/verify-token', (req, res, ctx) => res(
    ctx.json({
      status: 'OK',
      data: {},
    }),
  )),
  rest.post('*/api/v1/login', async (req, res, ctx) => {
    const requestBody = await req.json();
    const body: ArasResponse = {
      status: 'FAIL',
      code: 400,
      data: null,
      message: 'Error interno del servidor',
      extra: 'NotAuthorizedException',
    };
    if (requestBody.password === 'valid') {
      body.status = 'OK';
      body.code = 200;
      body.data = {
        user: {
          id: 'f79e82e8-c34a-4dc7-a49e-9fadc0979fda',
          email_verified: true,
        },
      };
      delete body.message;
      delete body.extra;
    }
    return res(
      ctx.json(body),
    );
  }),
  rest.post('*/api/v1/logout', (req, res, ctx) => {
    const response: ArasResponse = {
      status: 'OK',
      message: 'LogOut!',
      data: null,
      code: 200,
      extra: '',
    };
    return res(
      ctx.json(response),
    );
  }),
  rest.get('*/api/v1/verify-token', (req, res, ctx) => {
    const response: ArasResponse = {
      status: 'FAIL',
      message: 'Unauthorized',
      data: null,
      code: 401,
      extra: '',
    };

    if (req.cookies.csfrtoken === 'valid') {
      response.status = 'OK';
      response.message = 'Bienvenido a Autofact';
      response.data = {
        redirectTo: 'https://pro.autofact.qa',
        user: {
          email: 'hector.opazo@autofact.cl',
          email_verified: 'true',
          family_name: 'Opazo',
          given_name: 'Hector',
          name: 'Hector',
          phone_number: null,
          username: '2cbc49a5-da23-4917-82a9-123827fba231',
        },
      };
      response.code = 200;
      response.extra = '';
    }
    return res(
      ctx.json(response),
    );
  }),
  rest.post('*/api/v1/forgot-password', async (req, res, ctx) => {
    const requestBody = await req.json();
    if (requestBody.mail === 'fail@test.com') {
      return res.networkError('Gateway Timeout');
    }
    const body: ArasResponse = {
      status: 'OK',
      code: 200,
      data: {
        attribute_name: 'email',
        delivery_medium: 'EMAIL',
        destination: 's******@t*******',
      },
      message: 'Código de confirmación enviado a traves de EMAIL a s******@t*******',
      extra: '',
    };
    return res(
      ctx.json(body),
    );
  }),
  rest.post('*/api/v1/forgot-password/confirm', async (req, res, ctx) => {
    const requestBody = await req.json();
    if (requestBody.code === 'networkerror') {
      return res.networkError('Gateway Timeout');
    }
    let body: ArasResponse = {
      code: 200,
      status: 'OK',
    };

    if (requestBody.code === 'invalid') {
      body = {
        status: 'FAIL',
        code: 400,
        data: null,
        message: '\u003cb\u003eOops!\u003c/b\u003e el código de verificación ha caducado',
        extra: 'ExpiredCodeException',
      };
    }
    return res(
      ctx.json(body),
    );
  }),
  rest.post('*/api/v1/register', async (req, res, ctx) => {
    const requestBody = await req.json();
    let body: ArasResponse = {
      code: 200,
      status: 'OK',
    };
    if (requestBody.code === 'networkerror') {
      return res.networkError('Gateway Timeout');
    }
    switch (requestBody.code) {
      case 'FAIL':
        body = {
          status: 'FAIL',
          code: 400,
          data: {
            created: false,
            confirmed: false,
            resend: false,
          },
          message: '\u003cb\u003eOops!\u003c/b\u003e No se pudo conectar con la api',
          extra: 'ExpiredCodeException',
        };
        break;
      case 'ERROR':
        body = {
          status: 'ERROR',
          code: 400,
          data: {
            created: false,
            confirmed: false,
            resend: false,
          },
          message: '\u003cb\u003eOops!\u003c/b\u003e Ocurrio un error en la api',
          extra: 'ExpiredCodeException',
        };
        break;
      case 'NORESEND':
        body = {
          ...body,
          data: {
            created: true,
            confirmed: true,
          },
          message: 'usuario creado correctamente !',
          extra: 'ExpiredCodeException',
        };
        break;
      default:
        body = {
          ...body,
          data: {
            created: true,
            confirmed: true,
            resend: true,
          },
          message: '\u003cb\u003eOops!\u003c/b\u003e Se retorno resend',
          extra: 'ExpiredCodeException',
        };
        break;
    }
    console.log(body);
    return res(
      ctx.json(body),
    );
  }),
  rest.post('*/api/v1/register/confirm', async (req, res, ctx) => {
    const requestBody = await req.json();
    let body: ArasResponse = {
      code: 200,
      status: 'OK',
    };
    if (requestBody.code === 'networkerror') {
      return res.networkError('Gateway Timeout');
    }
    switch (requestBody.code) {
      case 'FAIL':
        body = {
          status: 'FAIL',
          code: 400,
          data: {
            confirmed: false,
          },
          message: '\u003cb\u003eOops!\u003c/b\u003e No se pudo conectar con la api',
          extra: 'ExpiredCodeException',
        };
        break;
      case 'ERROR':
        body = {
          status: 'ERROR',
          code: 400,
          data: {
            confirmed: false,
          },
          message: '\u003cb\u003eOops!\u003c/b\u003e Ocurrio un error en la api',
          extra: 'ExpiredCodeException',
        };
        break;
      default:
        body = {
          ...body,
          data: {
            confirmed: true,
          },
          message: 'usuario confirmado correctamente!',
          extra: 'ExpiredCodeException',
        };
        break;
    }
    return res(
      ctx.json(body),
    );
  }),
];

export default handlers;
